/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 9V15M12 9H9M12 9H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 6C5.10457 6 6 5.10457 6 4M4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4M4 6V18M6 4H18M18 4C18 5.10457 18.8954 6 20 6M18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4C22 5.10457 21.1046 6 20 6M20 18C18.8954 18 18 18.8954 18 20M20 18C21.1046 18 22 18.8954 22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20M20 18V6M18 20H6M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18M6 20C6 18.8954 5.10457 18 4 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4 6V12V18C5.10457 18 6 18.8954 6 20H12H18C18 18.8954 18.8954 18 20 18V12V6C18.8954 6 18 5.10457 18 4H12H6C6 5.10457 5.10457 6 4 6Z"
				fill="currentColor"
			/>
			<path
				d="M12 9V15M12 9H9M12 9H15M4 6C5.10457 6 6 5.10457 6 4M4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4M4 6V18M6 4H18M18 4C18 5.10457 18.8954 6 20 6M18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4C22 5.10457 21.1046 6 20 6M20 18C18.8954 18 18 18.8954 18 20M20 18C21.1046 18 22 18.8954 22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20M20 18V6M18 20H6M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18M6 20C6 18.8954 5.10457 18 4 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.3535 4.75H12H6.64648C6.38745 5.66584 5.66584 6.38745 4.75 6.64648V12V17.3535C5.66584 17.6125 6.38745 18.3342 6.64648 19.25H12H17.3535C17.6125 18.3342 18.3342 17.6125 19.25 17.3535V12V6.64648C18.3342 6.38745 17.6125 5.66584 17.3535 4.75ZM20.75 6.64648V12V17.3535C21.9043 17.68 22.75 18.7412 22.75 20C22.75 21.5188 21.5188 22.75 20 22.75C18.7412 22.75 17.68 21.9043 17.3535 20.75H12H6.64648C6.32002 21.9043 5.25878 22.75 4 22.75C2.48122 22.75 1.25 21.5188 1.25 20C1.25 18.7412 2.09575 17.68 3.25 17.3535V12V6.64648C2.09575 6.32002 1.25 5.25878 1.25 4C1.25 2.48122 2.48122 1.25 4 1.25C5.25878 1.25 6.32002 2.09575 6.64648 3.25H12H17.3535C17.68 2.09575 18.7412 1.25 20 1.25C21.5188 1.25 22.75 2.48122 22.75 4C22.75 5.25878 21.9043 6.32002 20.75 6.64648ZM9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H12H9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 9H15M12 11.5V15M4 9V18M6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4ZM6 4H15M20 15V6M18 20C18 21.1046 18.8954 22 20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20ZM18 20H9M4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20C6 18.8954 5.10457 18 4 18ZM20 6C21.1046 6 22 5.10457 22 4C22 2.89543 21.1046 2 20 2C18.8954 2 18 2.89543 18 4C18 5.10457 18.8954 6 20 6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 9V15M12 9H9M12 9H15M4 6C5.10457 6 6 5.10457 6 4M4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4M4 6V18M6 4H18M18 4C18 5.10457 18.8954 6 20 6M18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4C22 5.10457 21.1046 6 20 6M20 18C18.8954 18 18 18.8954 18 20M20 18C21.1046 18 22 18.8954 22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20M20 18V6M18 20H6M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18M6 20C6 18.8954 5.10457 18 4 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 4C5.25 3.58579 5.58579 3.25 6 3.25H12H18C18.4142 3.25 18.75 3.58579 18.75 4C18.75 4.41421 18.4142 4.75 18 4.75H12H6C5.58579 4.75 5.25 4.41421 5.25 4ZM4 5.25C4.41421 5.25 4.75 5.58579 4.75 6V12V18C4.75 18.4142 4.41421 18.75 4 18.75C3.58579 18.75 3.25 18.4142 3.25 18V12V6C3.25 5.58579 3.58579 5.25 4 5.25ZM20 5.25C20.4142 5.25 20.75 5.58579 20.75 6V12V18C20.75 18.4142 20.4142 18.75 20 18.75C19.5858 18.75 19.25 18.4142 19.25 18V12V6C19.25 5.58579 19.5858 5.25 20 5.25ZM5.25 20C5.25 19.5858 5.58579 19.25 6 19.25H12H18C18.4142 19.25 18.75 19.5858 18.75 20C18.75 20.4142 18.4142 20.75 18 20.75H12H6C5.58579 20.75 5.25 20.4142 5.25 20Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 1.25C18.4812 1.25 17.25 2.48122 17.25 4C17.25 5.51878 18.4812 6.75 20 6.75C21.5188 6.75 22.75 5.51878 22.75 4C22.75 2.48122 21.5188 1.25 20 1.25ZM17.25 20C17.25 18.4812 18.4812 17.25 20 17.25C21.5188 17.25 22.75 18.4812 22.75 20C22.75 21.5188 21.5188 22.75 20 22.75C18.4812 22.75 17.25 21.5188 17.25 20ZM1.25 20C1.25 18.4812 2.48122 17.25 4 17.25C5.51878 17.25 6.75 18.4812 6.75 20C6.75 21.5188 5.51878 22.75 4 22.75C2.48122 22.75 1.25 21.5188 1.25 20ZM1.25 4C1.25 2.48122 2.48122 1.25 4 1.25C5.51878 1.25 6.75 2.48122 6.75 4C6.75 5.51878 5.51878 6.75 4 6.75C2.48122 6.75 1.25 5.51878 1.25 4ZM9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H12H9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
